import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Page5.css';

import BG_EN from './../assets/page5/05_see_spray_EN.png';
import BG_PT from './../assets/page5/05_see_spray_PT.png';
import BG_ES from './../assets/page5/05_see_spray_ES.png';

function Page5() {
  const [activeImage, setActiveImage] = useState('PT');
  const navigate = useNavigate();

  useEffect(() => {
    window.language = activeImage;
  }, [activeImage]);

  return (
    <div className="page5-container">
      <img
        src={BG_EN}
        alt="English Background"
        className={`background-image ${activeImage === 'EN' ? 'active' : ''}`}
      />
      <img
        src={BG_PT}
        alt="Portuguese Background"
        className={`background-image ${activeImage === 'PT' ? 'active' : ''}`}
      />
      <img
        src={BG_ES}
        alt="Spanish Background"
        className={`background-image ${activeImage === 'ES' ? 'active' : ''}`}
      />
      <div className="switch-button" style={{ top: '791px', left: '218px', width: '76px', height: '50px' }} onClick={() => setActiveImage('PT')}></div>
      <div className="switch-button" style={{ top: '791px', left: '307px', width: '76px', height: '50px' }} onClick={() => setActiveImage('ES')}></div>
      <div className="switch-button" style={{ top: '791px', left: '394px', width: '76px', height: '50px' }} onClick={() => setActiveImage('EN')}></div>
      <div className="switch-button" style={{ top: '253px', left: '217px', width: '254px', height: '490px' }} onClick={() => navigate('/page5-1')}></div>
      <div className="switch-button" style={{ top: '253px', left: '495px', width: '254px', height: '490px' }} onClick={() => navigate('/page5-2')}></div>
    </div>
  );
}

export default Page5;
